import React from "react";
import { cejnToast, deleteCart } from "../../api/api";

// redux
import { useDispatch } from "react-redux";
import { setCart } from "../../redux/cartSlice";

export default function ClearCart() {
  const dispatch = useDispatch();

  React.useEffect(() => {
    clearCart();
  }, []);

  const clearCart = async () => {
    let data = await deleteCart();
    if (!data?.status.success) {
      cejnToast(data.status.message ?? i18n.getString("cejnToast.errors.clearCart"), "ERROR");
      return;
    }

    dispatch(setCart(data.items));
  };

  return <></>;
}
